<template>
  <div class="drawer-box">
    <!-- 论文管理详情 -->
    <div v-if="articleType === 0">
      <h1 class="title" v-html="details.title"></h1>
      <div class="release-box">
        <div>发布时间：{{ details.createTime }}</div>
        <!-- <div>创建人：{{details.createUser}}</div> -->
        <div>创建人：{{createName}}</div>
      </div>
      <div class="column">
        <span class="line"></span>
        <span style="vertical-align: middle">基本信息</span>
      </div>
      <div class="drawer-content">
        <div class="item" v-if="details.englishTitle">
          <span class="label">Tittle：</span>
          <span class="content" v-html="details.englishTitle"></span>
        </div>
        <div class="item">
          <div class="label">第一作者：</div>
          <div class="content content-auther">
            <span>{{ details.firstAuthor }}</span>
            <span>{{ details.firstAuthorUnit }}</span>
          </div>
        </div>
        <div class="item" v-if="details.articleAuthorList.length > 0">
          <div class="label">其他作者：</div>
          <div class="content other">
            <div class="other-auther" v-for="item in details.articleAuthorList" :key="item.id">
              <span>{{ item.authorName }}</span>
              <span>{{ item.authorUnit }}</span>
            </div>
          </div>
        </div>
        <div class="item" v-if="details.communicationAuthor">
          <div class="label">通讯作者：</div>
          <div class="content content-auther">
            <span>{{ details.communicationAuthor }}</span>
            <span>{{ details.communicationAuthorUnit }}</span>
          </div>
        </div>
        <div class="item">
          <span class="label">关键词：</span>
          <span class="content">{{details.keyword}}</span>
        </div>
        <div class="item" v-if="details.englishKeyword">
          <span class="label">Keywords：</span>
          <span class="content">{{details.englishKeyword}}</span>
        </div>
        <div class="item">
          <span class="label">摘要：</span>
          <span class="content" v-html="details.artSummary"></span>
        </div>
        <div class="item" v-if="details.englishArtSummary">
          <span class="label">Abstract：</span>
          <span class="content" v-html="details.englishArtSummary"></span>
        </div>
        <div class="item">
          <span class="label">刊名：</span>
          <span class="content">{{details.periodical}}</span>
        </div>
        <div class="item" v-if="details.englishPeriodical">
          <span class="label">Journal：</span>
          <span class="content">{{details.englishPeriodical}}</span>
        </div>
        <div class="item">
          <span class="label">刊期：</span>
          <span class="content">{{ details.journalsYear }}年第{{details.journalsVolume ? details.journalsVolume+'卷第' : ''}}{{ details.journalsTerm }}期</span>
        </div>
        <div class="item">
          <span class="label">栏目：</span>
          <span class="content">{{details.articleColumn}}</span>
        </div>
        <div class="item" v-if="details.fundStr">
          <span class="label">基金项目：</span>
          <span class="content">{{details.fundStr}}</span>
        </div>
        <div class="item">
          <span class="label">分类号：</span>
          <span class="content">{{details.classifyNumber}}</span>
        </div>
        <div class="item" v-if="details.doi">
          <span class="label">DOI：</span>
          <span class="content">{{details.doi}}</span>
        </div>
        <div class="item">
          <span class="label">页数：</span>
          <span class="content">{{details.pageNumber}}</span>
        </div>
        <div class="item">
          <span class="label">页码：</span>
          <span class="content">{{details.sizeNumber}}</span>
        </div>
        <div class="item">
          <span class="label">数据库收录：</span>
          <span class="content">{{details.dataStyle}}</span>
        </div>
        <div class="item">
          <span class="label">附件：</span>
          <span class="content">
            <span class="file-name" style="margin-right: 80px;">{{details.accessoryName}}</span>
            <span class="file-btn" style="margin-right: 15px;" @click="filePreview">预览</span>
            <span class="file-btn" @click="fileDown">下载</span>
          </span>
        </div>
      </div>
    </div>
    <!-- 专著管理详情 -->
    <div v-else-if="articleType === 2">
      <h1 class="title" v-html="details.monographName"></h1>
      <div class="release-box">
        <div>发布时间：{{ details.createTime }}</div>
        <!-- <div>创建人：{{details.createUser}}</div> -->
        <div>创建人：{{createName}}</div>
      </div>
      <div class="column">
        <span class="line"></span>
        <span style="vertical-align: middle">基本信息</span>
      </div>
      <div class="drawer-content">
        <div class="item">
          <span class="label">封面：</span>
          <img class="content-img" v-lazy="$global.imgUrl + details.cover" alt="">
        </div>
        <div class="item">
          <div class="label">作者：</div>
          <span class="content">{{details.monographAuthor}}</span>
        </div>
        <div class="item" v-if="details.translatorJson && details.translatorJson.length > 0">
          <div class="label">译者：</div>
          <span class="content">{{ details.translatorJson.toString() }}</span>
        </div>
        <div class="item">
          <span class="label">出版社：</span>
          <span class="content">{{details.press}}</span>
        </div>
        <div class="item">
          <span class="label">出版时间：</span>
          <span class="content">{{details.showPublishTime}}</span>
        </div>
        <div class="item">
          <span class="label">ISBN：</span>
          <span class="content">{{details.isbn}}</span>
        </div>
        <div class="item">
          <span class="label">版次：</span>
          <span class="content">{{details.edition}}</span>
        </div>
        <div class="item">
          <span class="label">页数：</span>
          <span class="content">{{details.pageNumber}}</span>
        </div>
        <div class="item">
          <span class="label">字数：</span>
          <span class="content">{{details.monographLenght}}</span>
        </div>
        <div class="item">
          <span class="label">分类号：</span>
          <span class="content">{{details.classifyNumber}}</span>
        </div>
        <div class="item">
          <span class="label">内容简介：</span>
          <span class="content">{{details.artSummary}}</span>
        </div>
        <div class="item">
          <span class="label">目录：</span>
          <span class="content" v-html="details.catalogue"></span>
        </div>
        <div class="item">
          <span class="label">目录：</span>
          <span class="content" v-html="details.catalogue"></span>
        </div>
        <div class="item" v-if="details.payUrl">
          <span class="label">商品链接：</span>
          <span class="content">{{details.payUrl}}</span>
        </div>
        <div class="item" v-if="details.accessoryName">
          <span class="label">附件：</span>
          <span class="content">
            <span class="file-name" style="margin-right: 80px;">{{details.accessoryName}}</span>
            <span class="file-btn" style="margin-right: 15px;" @click="filePreview">预览</span>
            <span class="file-btn" @click="fileDown">下载</span>
          </span>
        </div>
      </div>
    </div>
    <!-- 万商数据报告详情 -->
    <div v-else-if="articleType === 6">
      <h1 class="title" v-html="details.reportName"></h1>
      <div class="release-box">
        <div>发布时间：{{ details.createTime }}</div>
        <!-- <div>创建人：{{details.createUser}}</div> -->
        <div>创建人：{{createName}}</div>
      </div>
      <div class="column">
        <span class="line"></span>
        <span style="vertical-align: middle">基本信息</span>
      </div>
      <div class="drawer-content">
        <div class="item" v-if="details.englishName">
          <div class="label">Title：</div>
          <span class="content">{{details.englishName}}</span>
        </div>
        <div class="item">
          <span class="label">封面：</span>
          <img class="content-img" v-lazy="$global.imgUrl + details.cover" alt="">
        </div>
        <div class="item">
          <div class="label">报告编号：</div>
          <span class="content">{{details.reportCode}}</span>
        </div>
        <div class="item">
          <span class="label">报告类型：</span>
          <span class="content">{{details.reportCharge === 1 ? '免费版' : '付费版'}}</span>
        </div>
        <div class="item">
          <span class="label">报告页码：</span>
          <span class="content">{{details.sizeNumber}}</span>
        </div>
        <div class="item">
          <span class="label">表格数量：</span>
          <span class="content">{{details.reportNumber}}</span>
        </div>
        <div class="item">
          <span class="label">寄送方式：</span>
          <span class="content">{{details.sendWay}}</span>
        </div>
        <div class="item" v-if="details.chinesePrice">
          <span class="label">中文版全价：</span>
          <span class="content">{{details.chinesePrice}}</span>
        </div>
        <div class="item" v-if="details.electronicPrice">
          <span class="label">中文电子版：</span>
          <span class="content">{{details.electronicPrice}}</span>
        </div>
        <div class="item" v-if="details.printingPrice">
          <span class="label">中文印刷版：</span>
          <span class="content">{{details.printingPrice}}</span>
        </div>
        <div class="item" v-if="details.englishPrice">
          <span class="label">英文版全价：</span>
          <span class="content">{{details.englishPrice}}</span>
        </div>
        <div class="item" v-if="details.electronicEnglishPrice">
          <span class="label">英文电子版：</span>
          <span class="content">{{details.electronicEnglishPrice}}</span>
        </div>
        <div class="item" v-if="details.printingEnglishPrice">
          <span class="label">英文印刷版：</span>
          <span class="content">{{details.printingEnglishPrice}}</span>
        </div>
        <div class="item">
          <span class="label">行业分类：</span>
          <span class="content">{{details.businessId1name}}-{{details.businessId2name}}</span>
        </div>
        <div class="item">
          <span class="label">内容介绍：</span>
          <span class="content">{{details.content}}</span>
        </div>
        <div class="item">
          <span class="label">目录：</span>
          <span class="content" v-html="details.catalogue"></span>
        </div>
        <div class="item">
          <span class="label">附件：</span>
          <span class="content">
            <span class="file-name" style="margin-right: 80px;">{{details.accessoryName}}</span>
            <span class="file-btn" style="margin-right: 15px;" @click="filePreview">预览</span>
            <span class="file-btn" @click="fileDown">下载</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: ["articleId", "articleType"],
  created() {
    this.getEcho(this.articleId, this.articleType);
  },
  computed: {
    ...mapState(["hasLogin", "token"]),
  },
  data() {
    return {
      details: {},
      createName: '',
    };
  },
  methods: {
    // 附件预览
    async filePreview() {
      if (!this.hasLogin) {
        this.$bus.$emit("showModel", true);
        return;
      }
      let obj = {
        articleId: this.articleId,
        articleType: this.articleType,
      };
      let res = await this.$apis.mainServe.hasFile(obj);
      if (res.resultCode !== "200") {
        this.$Message.error("没有文献");
        return false;
      }
      window.open(
        this.$apis.mainServe.readUrl +
          "?articleId=" +
          this.articleId +
          "&articleType=" +
          this.articleType +
          "&token=" +
          this.token
      );
    },
    // 附件下载
    async fileDown() {
      if (!this.hasLogin) {
        this.$bus.$emit("showModel", true);
        return;
      }
      let obj = {
        articleId: this.articleId,
        articleType: this.articleType,
      };
      let res = await this.$apis.mainServe.hasFile(obj);
      if (res.resultCode !== "200") {
        this.$Message.error("没有文献");
        return false;
      }
      window.open(
        this.$apis.mainServe.download +
          "?articleId=" +
          this.articleId +
          "&articleType=" +
          this.articleType +
          "&token=" +
          this.token
      );
    },
    // 获取详情
    async getEcho(articleId, articleType) {
      const resp = await this.$apis.userServe.getEcho({
        articleId,
        articleType,
      });
      this.createName = resp.data.createUserName
      this.details = resp.data.data;
    },
  },
};
</script>

<style lang="scss" scoped>
.drawer-box {
  padding: 0 20px 20px;
  .title {
    font-size: 26px;
    font-weight: 400;
    color: #333333;
    line-height: 48px;
  }
  .release-box {
    margin: 10px 0 48px;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    color: #333333;
  }
  .column {
    display: flex;
    align-items: center;
    font-size: 18px;
    color: #3c3c3c;
    .line {
      margin-right: 14px;
      width: 4px;
      height: 16px;
      background: #4343c1;
    }
  }
  .drawer-content {
    margin-top: 25px;
    .item {
      display: flex;
      .label {
        margin-right: 15px;
        width: 85px;
        font-size: 14px;
        font-weight: bold;
        color: #333333;
        line-height: 30px;
      }
      .content {
        width: 550px;
        font-size: 14px;
        color: #000000;
        line-height: 30px;
        .file-name {
          display: inline-block;
          max-width: 300px;
        }
        .file-btn {
          color: #152EAD;
          cursor: pointer;
        }
        &::v-deep img, 
        &::v-deep video{
          max-width: 100% !important;
        }
        &::v-deep span {
          white-space: normal !important;
        }
      }
      .content-auther {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }
      .other {
        .other-auther {
          display: flex;
          justify-content: space-between;
        }
      }
      .content-img {
        width: 86px;
        height: 100px;
      }
    }
  }
}
</style>